import * as React from 'react';
import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-9 w-full min-w-0 rounded-sm border-0 bg-[var(--surface-container-highest)] px-3 py-1 text-base shadow-none transition-[background-color,box-shadow] outline-none md:text-sm',
        'text-foreground placeholder:text-muted-foreground',
        'selection:bg-primary selection:text-primary-foreground',
        'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
        'focus-visible:bg-[var(--surface-container-lowest)] focus-visible:ring-2 focus-visible:ring-[rgba(0,8,30,0.2)]',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:ring-destructive/25',
        className
      )}
      {...props}
    />
  );
}

export { Input };
